const LATEST_AVAILABLE_YEAR = 2020;
const EARLIEST_AVAILABLE_YEAR = 1940;

const QUESTION_PROMPT_PERCENTAGE_GUESS = "How many percent of the survey respondents answered..."
const QUESTION_PROMPT_RANKING_ALL = "From most commonly answered to least commonly answered, what do most respondents say to..."
const QUESTION_PROMPT_TOP_1 = "Which are the top 1 most popular answer respondents say to..."
const QUESTION_PROMPT_PIE = "Match response options to the corresponding proportion of respondents that picked the option when answering..."
const QUESTION_PROMPT_LIKERT = "What are the response proportions to the question..."
const HOMEPAGE_URL = window.location.href
const QUESTIONS_PER_GAME_STOP = 2
const GAME_STOP_NUMBER = 8

const GAME_STOPS_CAPTIONS = [
    {
        gameStopTitle: "Saddle Up-Oregon State Fair Campaign Launch.",
        gameStopDescription: "You are making the big announcement: you're running with a promise to represent the views of the people. \
            The speech needs to  address the biggest problems on voters' minds - and you need to be ready for the press to ask questions \
            about the fiercest debates in the race. Topics could include a Most Important Problem - or almost anything else! Do you have \
            the data to reach the most voters?"
    },
    {
        gameStopTitle: "Theodore Roosevelt High School - High School Graduation.",
        gameStopDescription: " You  will address the graduating class of Theodore Roosevelt High School in Wilton, Wyoming. Topics include \
            Environment, Guns, Drugs, and Education. Do you have the data to reach the youth?"
    },
    {
        gameStopTitle: "The Elizabeth Cady Stanton Society for the Advancement of Women.",
        gameStopDescripion: "You are keynote speaker for The Elizabeth Cady Stanton Society for the Advancement of Women's annual meeting. \
            Topics include Women in the Workforce, Women's Role in Society, and Women's Health. Do you have the data to reach women voters?"
    },
    {
        gameStopTitle: "Going Down into the Mine Laborer's Union.",
        gameStopDescripion: "You will put on a pair of ill-fitting overalls and be addressing the Mine Laborer's Union. Topics to include Labor, \
            Environment, and Health. Do you have the data to reach the labor block?"
    },
    {
        gameStopTitle: "Fort America Army Base.",
        gameStopDescripion: "You will salute the troops at Fort America. Topics to be covered will be: Defense Spending and US Role in the World. \
            Do you have the data to reach the members of the military?"
    },
    {
        gameStopTitle: "Businesspeople for More Businesslike Business Luncheon.",
        gameStopDescripion: "You will speak to the largest business lunch ever convened. Topics addressed include Economy, Immigration, Role of \
            Government. Do you have the data to reach the business voters?"
    },
    {
        gameStopTitle: "Mic Drop: Time to Debate!",
        gameStopDescripion: "You need to prepare for a head to head showdown in front of a national audience. Do you have the data to reach the \
            most voters?"
    },
    {
        gameStopTitle: "Shady Grove Senior Living Early Bird Breakfast.",
        gameStopDescripion: "Get up early to address senior voters. Topics include Health Care and Seniors."
    }
]

export {
    LATEST_AVAILABLE_YEAR,
    EARLIEST_AVAILABLE_YEAR,
    QUESTION_PROMPT_PERCENTAGE_GUESS,
    QUESTION_PROMPT_RANKING_ALL,
    QUESTION_PROMPT_TOP_1,
    QUESTION_PROMPT_PIE,
    QUESTION_PROMPT_LIKERT,
    HOMEPAGE_URL,
    QUESTIONS_PER_GAME_STOP,
    GAME_STOP_NUMBER,
    GAME_STOPS_CAPTIONS
};